import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MunicipalitiesService } from '../municipalities.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-edit-municipalities',
  templateUrl: './edit-municipalities.component.html',
  styleUrls: ['./edit-municipalities.component.scss']
})
export class EditMunicipalitiesComponent implements OnInit {
  dataToDisplay;

  initialData$: Observable<any>;


  constructor(private route: ActivatedRoute,
    private municipalitiesService: MunicipalitiesService) { }

  ngOnInit() {

    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      console.log("id________ EditMunicipalitiesComponent");
      console.log(id);

      if (id) {
        this.getMunicipalityById(id);
      }
    });
  }


  getMunicipalityById(id: string) {
    this.initialData$ = this.municipalitiesService.getMunicipalityById(id);
    this.initialData$.subscribe(data => {
      console.log("data_________________ getMunicipalityById EDIT!!!!!!!!!!");
      console.log(data);
    });
  }

}
